import { c as _c } from "react/compiler-runtime";
import { useQuery } from '@tanstack/react-query';
import { AuthQueryOptions, UnauthQueryOptions } from '@/api';
import type { NonsanRouletteEntry } from '../_utils/resolveNonsanRouletteEntry';
import { resolveNonsanRouletteEntry } from '../_utils/resolveNonsanRouletteEntry';
interface UseNonsanRouletteEntryParams {
  institutionName: string;
  paidAt: string;
  epayNumber: string;
}

//* 로그인 전용 화면(기부 내역·기부 완료)에서만 쓴다 — 참여 상태 쿼리가 인증을 전제한다.
export const useNonsanRouletteEntry = params => {
  const $ = _c(14);
  let t0;
  if ($[0] !== params.institutionName) {
    t0 = params.institutionName.includes("\uB17C\uC0B0");
    $[0] = params.institutionName;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  const isCandidate = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = UnauthQueryOptions["get:/wello/v2/allows/nonsan-roulette"]();
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== isCandidate) {
    t2 = {
      ...t1,
      select: _temp,
      enabled: isCandidate
    };
    $[3] = isCandidate;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const config = useQuery(t2);
  let t3;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = AuthQueryOptions["get:/wello/v2/auth/nonsan-roulette/status"]();
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  let t4;
  if ($[6] !== isCandidate) {
    t4 = {
      ...t3,
      select: _temp2,
      enabled: isCandidate
    };
    $[6] = isCandidate;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const status = useQuery(t4);
  let t5;
  if ($[8] !== config.data || $[9] !== config.isLoading || $[10] !== params || $[11] !== status.data || $[12] !== status.isLoading) {
    t5 = resolveNonsanRouletteEntry({
      ...params,
      config: config.data,
      status: status.data,
      isStatusLoading: status.isLoading,
      isConfigLoading: config.isLoading
    });
    $[8] = config.data;
    $[9] = config.isLoading;
    $[10] = params;
    $[11] = status.data;
    $[12] = status.isLoading;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
function _temp(t0) {
  const {
    context
  } = t0;
  return context;
}
function _temp2(t0) {
  const {
    context: context_0
  } = t0;
  return context_0;
}